import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { FeatureInitResponse } from '../../types';
import type { PermissionV2Model } from '../permission-v2-model';

@injectable()
export class PermissionV2ModelImpl extends AbstractModel<FeatureInitResponse | null> implements PermissionV2Model {
    protected _modelData: FeatureInitResponse | null = null;
}
